import React from "react";
import { COMPANY } from "../data/site";
import { Play, Sparkles } from "lucide-react";
import useReveal from "../hooks/useReveal";

const VideoSection = () => {
  const [ref, inView] = useReveal();
  return (
    <section
      ref={ref}
      className={`relative py-28 bg-[#fffaf3] reveal ${inView ? "in-view" : ""}`}
      data-testid="video-section"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-100 border border-orange-200 text-orange-700 text-[10px] font-extrabold tracking-[0.25em] uppercase font-mono mb-5">
            <Sparkles className="w-3 h-3" /> See us in action
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold text-[#1a0a05] leading-[0.95] tracking-tight">
            Inside <span className="text-heat brush">our factory</span>.
          </h2>
          <p className="text-[#3a2418] mt-5 max-w-2xl mx-auto">
            A walk-through of our manufacturing floor, R&amp;D lab and quality testing — the heart behind every heater we ship.
          </p>
        </div>

        <div className="relative aspect-video w-full rounded-3xl overflow-hidden border border-orange-200/60 shadow-[0_40px_100px_-30px_rgba(229,57,53,0.55)] bg-black">
          <iframe
            src={`https://www.youtube.com/embed/${COMPANY.videoId}?rel=0`}
            title="ESS BEE HEATERS PVT. LTD."
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
            data-testid="company-video"
          />
        </div>

        <div className="mt-5 text-center text-xs text-[#3a2418]/70 inline-flex items-center justify-center gap-2 w-full font-mono uppercase tracking-[0.2em]">
          <Play className="w-3.5 h-3.5 text-orange-600" /> Official video · ESS BEE HEATERS PVT. LTD.
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
